import { extInfo } from 'lib/extInfo';
import { stringify } from 'qs';
import { SearchOptionType } from 'reactApp/sections/AlbumsPage/SelectFromCloudPopup/components/SelectFromCloudSearch/SelectFromCloudSearch.types';
import { ESearchOptionSource, ESearchOptionType } from 'reactApp/ui/WebSearch/WebSearch.data';

export const SEARCH_PER_PAGE_LIMIT = 500;

export const getExtsBySearchType = (searchType: string, isAlbumsSearch: boolean) => {
    if (searchType === SearchOptionType.media && isAlbumsSearch) {
        return extInfo.getExtsForAlbums().join(',');
    }

    if (isAlbumsSearch) {
        return extInfo.getExtsForAlbumsByKind(searchType).join(',');
    }

    return extInfo.getExtsByKind(searchType).join(',');
};

export const getSearchQueryString = (
    query: string,
    { searchType, searchSource }: { searchType?: ESearchOptionType; searchSource?: ESearchOptionSource }
) => stringify({ query, searchType, searchSource }, { addQueryPrefix: true });

export const convertParamFilesSearchType = (searchType?: ESearchOptionSource) => {
    switch (searchType) {
        case ESearchOptionSource.name:
            return 'by_name';
            break;
        case ESearchOptionSource.content:
            return 'by_content';
            break;
        case ESearchOptionSource.all:
            return 'by_name,by_content';
            break;
        default:
            return '';
    }
};
